import Vue from "vue";

class RequestModel {
  constructor(object) {
    this._method = object.method ? object.method : "get";
    this._url = object.url ? object.url : "";
    this._params = object.params ? object.params : {};
    this._data = object.data ? object.data : {};
    this._headers = object.headers ? object.headers : undefined;
    this._responseType = object.responseType ? object.responseType : "json";
  }

  get headers() {
    return this._headers;
  }
  set headers(headers) {
    this._headers = headers;
  }
  get method() {
    return this._method;
  }

  set method(method) {
    this._method = method;
  }

  get url() {
    return this._url;
  }

  set url(url) {
    this._url = url;
  }

  get params() {
    return this._params;
  }

  set params(params) {
    this._params = params;
  }

  get data() {
    return this._data;
  }

  set data(data) {
    this._data = data;
  }

  get responseType() {
    return this._responseType;
  }

  set responseType(responseType) {
    this._responseType = responseType;
  }

  defaultConfig() {
    let content = this.headers ? this.headers["Content-Type"] : undefined;

    let headers = {
      "Content-Type":
        content == undefined ? "application/x-www-form-urlencoded" : content,
    };
    if (localStorage.getItem("token")) {
      headers = {
        Authorization: localStorage.getItem("token"),

        "Content-Type":
          content == undefined ? "application/x-www-form-urlencoded" : content,
        withCredentials: true,
      };
    }

    if (this.method === "get" || this.method === "delete") {
      return {
        method: this.method,
        url: this.url,
        params:
          Object.keys(this.params).length > 0
            ?  this.params
            : {},
        headers: headers,
        responseType: this.responseType,
      };
    }

    //  configure header
    if (this.method === "post") {
      return {
        method: this.method,
        url: this.url,
        params:
          Object.keys(this.params).length > 0
            ?  this.params
            : {},
        data:
          Object.keys(this.data).length > 0
            ?  this.data
            : {},
        headers: headers,
        responseType: this.responseType,
      };
    }

    return {
      method: this.method,
      url: this.url,
      params:
        Object.keys(this.params).length > 0
          ?  this.params
          : {},
      data:
        Object.keys(this.data).length > 0
          ?  this.data
          : {},
      headers: this.headers,
      responseType: this.responseType,
    };
  }

  tokenConfig(vue) {
    let headers;
    if (localStorage.getItem("token")) {
      let content = this.headers ? this.headers["Content-Type"] : undefined;
      headers = {
        Authorization: localStorage.getItem("token"),

        "Content-Type":
          content == undefined ? "application/x-www-form-urlencoded" : content,
        withCredentials: true,
      };
    }

    if (this.method === "get" || this.method === "delete") {
      return {
        method: this.method,
        url: this.url,
        params:
          Object.keys(this.params).length > 0
            ? this.params
            : {},
        headers: headers,
        responseType: this.responseType,
      };
    }
    return {
      method: this.method,
      url: this.url,
      params:
        Object.keys(this.params).length > 0
          ? this.params
          : {},
      data:
        Object.keys(this.data).length > 0
          ? this.data
          : {},
      headers: headers,
      responseType: this.responseType,
    };
  }
}

export default RequestModel;
